import { render, staticRenderFns } from "./SkillModel.vue?vue&type=template&id=09e0d226&scoped=true"
import script from "./SkillModel.vue?vue&type=script&lang=js"
export * from "./SkillModel.vue?vue&type=script&lang=js"
import style0 from "./SkillModel.vue?vue&type=style&index=0&id=09e0d226&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e0d226",
  null
  
)

export default component.exports